import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AttachmentsDownloadModal from "../Attachments/Attachments";
import noImage from "../../../../../../assets/images/noImage.png";
import pdfIcon from "../../../../../../assets/icons/pdfIcon.png";
import excelIcon from "../../../../../../assets/icons/excelIcon.png";
import docsIcon from "../../../../../../assets/icons/docsIcon.png";
import { checkFileType, convertTime } from "../../../../../../helpers/helpers";
import ImagesModal from "../../../../../Shipper/Customer/MainPages/Orders/Components/OrderHistoryModal/ImagesModal/ImagesModal";
import {
  isVideoAttachment,
  VideoTile,
} from "../../../../../../Components/AttachmentVideo/AttachmentVideo";

// One tracking entry or note. On screen its cells get a wrapper that phones
// and tablets show as a card; on desktop the wrapper has no box of its own
// (display: contents), so the cells sit in the grid as before. The PDF copy
// keeps the bare cells.
const GridRow = ({ print, children }) =>
  print ? (
    <>{children}</>
  ) : (
    <div className="order_detail_grid_row">{children}</div>
  );

export default function Trackingandnotes({ data, type = "show" }) {
  const { t } = useTranslation("warehouse");
  const [attachmentsModal, setAttachmentsModal] = useState();
  const [fullview, setfullview] = useState();

  return (
    <>
      <ImagesModal setOpen={setfullview} open={fullview} />
      <div className="shipment_attachments_main_wrap">
        <div className="shipment_tracking_wrap">
          {/* shipment tracking */}
          <div className="invmodal__shipment_detailshding">
            {t("orderDetails.shipmentTracking")}
          </div>
          {data?.shipment?.shipment_histories?.length > 0 ? (
            <>
              <div className="invmodal__shshiptracking_grid  shipment_tracking_wrap">
                <div className="invmodal__shdetails_gridhd">
                  {t("orderDetails.shipmentStatus")}
                </div>
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.statusDate")}</div>
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.statusTime")}</div>
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.lastLocation")}</div>
                {data?.shipment?.shipment_histories?.map((history, index) => {
                  return (
                    <GridRow key={index} print={type === "print"}>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-card="title"
                      >
                        {history?.ShipmentStatus ?? "-"}
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.statusDate")}
                      >
                        {history?.StatusDate?.slice(0, 10) ?? "-"}
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.statusTime")}
                      >
                        {" "}
                        {history?.StatusDate?.slice(11, 16) ?? "-"}
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.lastLocation")}
                        data-card="wide"
                      >
                        {" "}
                        {history?.LastLocation ?? "-"}
                      </div>
                    </GridRow>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="shipment_order_not_available">
              <p>
                {data?.shipment?.shipment_histories
                  ? t("orderDetails.noShipmentHistoryAvailabe")
                  : t("orderDetails.shipmentNotAvailable")}
              </p>
            </div>
          )}
          {/* shipment tracking */}
        </div>
        <div className="notes_attachments_wrap notes_attachment_col">
          {/* Notes Attachment */}

          <div className="invmodal__shipment_detailshding">
            {t("orderDetails.orderNotesAndAttachments")}
          </div>
          {data?.order_notes?.length > 0 ? (
            <>
              <div className="invmodal__shshiptracking_grid   shipment_tracking_wrap">
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.note")}</div>
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.noteBy")}</div>
                <div className="invmodal__shdetails_gridhd">{t("orderDetails.noteAt")}</div>
                <div className="invmodal__shdetails_gridhd">
                  {t("orderDetails.attachmentsIncluded")}
                </div>
                {data?.order_notes?.map((note, index) => {
                  return (
                    <GridRow key={index} print={type === "print"}>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.note")}
                        data-card="wide"
                      >
                        <div className="tracking_notes_conten_box">
                          {note?.note ?? "-"}
                        </div>
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.noteBy")}
                      >
                        {note?.created_by?.username ?? "-"}
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={t("orderDetails.noteAt")}
                      >
                        {convertTime(note?.created_at)}
                      </div>
                      <div
                        className="invmodal__shdetails_griditem"
                        data-label={
                          note?.order_attachments?.length > 0
                            ? t("orderDetails.attachments")
                            : undefined
                        }
                        data-card="wide"
                      >
                        {" "}
                        {index === attachmentsModal && (
                          <AttachmentsDownloadModal
                            onClose={() => setAttachmentsModal()}
                            open={note?.order_attachments}
                            type="user"
                          />
                        )}
                        {note?.order_attachments?.length > 0 &&
                        type !== "print" ? (
                          <div className="order_detail_view_thumbnails_wrap_main">
                            <div className="order_detail_view_thumbnails_wrap">
                              {note?.order_attachments?.map((list, index) =>
                                isVideoAttachment(list) ? (
                                  <VideoTile
                                    key={list?.id ?? index}
                                    src={list?.file}
                                    label={`Video ${index + 1}`}
                                    style={{ width: 60, height: 60 }}
                                  />
                                ) : (
                                <img
                                  key={list?.id ?? index}
                                  src={
                                    list?.file &&
                                    checkFileType(list.file) === "Image"
                                      ? list.file
                                      : checkFileType(list.file) === "PDF"
                                      ? pdfIcon
                                      : checkFileType(list.file) === "Excel"
                                      ? excelIcon
                                      : checkFileType(list.file) === "Document"
                                      ? docsIcon
                                      : noImage
                                  }
                                  alt={t("orderDetails.attachmentNumber", { number: index + 1 })}
                                  onError={(e) => {
                                    e.target.src = noImage;
                                  }}
                                  loading="lazy"
                                  onClick={() => {
                                    if (checkFileType(list.file) === "Image") {
                                      setfullview(list?.file || "");
                                    } else {
                                      window.open(list?.file, "_blank");
                                    }
                                  }}
                                />
                                ),
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </GridRow>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="not_data_found_shipment_attachment">
              <p>{t("orderDetails.notesAndAttachmentsNotAvailable")}</p>
            </div>
          )}
          {/* Notes Attachment */}
        </div>
      </div>
    </>
  );
}
